(() => {
  const initMegaMenuRevealButtons = () => {
    document.querySelectorAll('.see-more-button').forEach(button => {
      if (button.dataset.revealMoreInitialized === 'true') {
        return;
      }

      button.dataset.revealMoreInitialized = 'true';

      const collapsedText = button.dataset.collapsedText || button.textContent.trim() || 'See older models';
      const expandedText = button.dataset.expandedText || 'See fewer models';

      button.addEventListener('click', event => {
        event.preventDefault();

        const parentItem = button.closest('li');
        const nestedList = parentItem
          ? Array.from(parentItem.children).find(child => child.tagName === 'UL')
          : null;

        if (!nestedList) {
          return;
        }

        // Only target submenu items after the 9th item.
        const itemsToToggle = Array.from(nestedList.children).slice(9);
        const isExpanded = button.classList.contains('expanded');

        itemsToToggle.forEach(item => {
          item.classList.toggle('hidden-item', isExpanded);
        });

        button.classList.toggle('expanded', !isExpanded);
        button.setAttribute('aria-expanded', String(!isExpanded));
        button.textContent = isExpanded ? collapsedText : expandedText;
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaMenuRevealButtons, { once: true });
  } else {
    initMegaMenuRevealButtons();
  }

  document.addEventListener('shopify:section:load', initMegaMenuRevealButtons);
})();
